import { z } from "zod/v4";

import { createEndpointBase } from "./core";
import { EndpointsSchemas } from "../ea.schema.endpoints";

const base = "export";
const exp = createEndpointBase(base);

export const exportEndpoints = {
  exportDownload: exp({
    method: "POST",
    path: "download",
    request: z.object({ fileName: z.string() }),
    response: z.any(),
    description: "Downloads an exported file by name.",
  }),
  exportGenerate: exp({
    method: "POST",
    path: "generate",
    request: EndpointsSchemas.export.generate,
    response: z.any(),
    description: "Generates an export for a specific model based on filters.",
  }),
} as const;
